module.exports = __webpack_public_path__ + "static/THNG-message-contact-312e85904f69b1f92d632ca4e51e0d25.png";